import { useEffect } from 'react';

interface GlobalKeyboardShortcutsOptions {
    onCommandK?: () => void;
    /** Plain `/`, ignored while typing in a field so it can still be entered as text. */
    onSlash?: () => void;
    enabled?: boolean;
}

function isEditableTarget(target: EventTarget | null): boolean {
    if (!(target instanceof HTMLElement)) {
        return false;
    }

    return target.isContentEditable || target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.tagName === 'SELECT';
}

export function useGlobalKeyboardShortcuts({ onCommandK, onSlash, enabled = true }: GlobalKeyboardShortcutsOptions) {
    useEffect(() => {
        if (!enabled) {
            return;
        }

        const handler = (e: KeyboardEvent) => {
            if (onCommandK && (e.metaKey || e.ctrlKey) && e.key === 'k') {
                e.preventDefault();
                onCommandK();
                return;
            }

            if (onSlash && e.key === '/' && !e.metaKey && !e.ctrlKey && !e.altKey && !e.defaultPrevented && !isEditableTarget(e.target)) {
                e.preventDefault();
                onSlash();
            }
        };

        document.addEventListener('keydown', handler);
        return () => document.removeEventListener('keydown', handler);
    }, [enabled, onCommandK, onSlash]);
}
